<template>
  <div>
    <b-list-group-item
      v-for="key in Object.keys($t('faq')).filter(key => !/(intro|title|icon|svg)/.test(key))"
      :key="key"
      :href="`#${getFramaname(key) !== undefined
        ? $t(getFramaname(key), '-tlL').replace(/[^a-z]/g, '')
        : key}`"
      class="d-none d-lg-block text-muted"
    >
      <svg-icon
        :label="getFramaname(key) ? getFramaname(key) : $t(`faq.${key}.title`)"
        :name="getSectionIcon(key)"
        variant="fc-g6"
      />
    </b-list-group-item>
  </div>
</template>

<script>
export default {
  methods: {
    getFramaname(key) {
      return this.$te(`color.${this.$t(key, '-k~lL@')}`)
        ? this.$t(`color.${this.$t(key, '-k~lL@')}`)
        : undefined;
    },

    getSectionIcon(key) {
      let svg = 'question-circle';
      if (this.$te(`svg.${this.$t(key, '-k~L@')}`)) {
        svg = this.$t(`svg.${this.$t(key, '-k~L@')}`);
      }
      if (this.$te(`faq.svg.${key}`)) {
        svg = this.$t(`faq.svg.${key}`);
      }
      return svg;
    },
  },
};
</script>
